export interface WorkspaceProps {
  id: string;
  icon: string;
  route: string;
  title: string;
  subTitle: string;
}

export const STATIC_WORKSPACE: WorkspaceProps[] = [
  {
    id: '/workspace/draft',
    icon: 'Grid',
    route: 'DRAFT',
    title: 'Template Gallery',
    subTitle: 'Choose a template and customize it to use'
  },
  {
    id: '/workspace/templates',
    icon: 'Layers',
    route: 'TEMPLATE',
    title: 'Template Gallery',
    subTitle: 'Choose a template and customize it to use'
  }
];
